import {Component} from '@angular/core';
import {ViewController} from 'ionic-angular';
import {NavController, NavParams} from 'ionic-angular';

import {TGoogleAnalytic, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {CONFIG} from "../../../app/config";

import {DataService} from "../../../providers/data-service";

@Component({
    selector: 'page-showview-lista',
    templateUrl: 'showview-lista.html',
    providers: []
})

export class ShowviewListaPage {

    config: any;
    logado: any;
    perfil: any;


    tipo: string = '';

    arrayData: any;
    indexSelecionadoModal: any = '';

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public viewCtrl: ViewController,
                public dataService: DataService,
                public logadoService: LogadoService) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.perfil = this.logado;

        this.arrayData = this.util.anyParams(this.navParams.get('atracaoData'), this.navParams.get('novidadeData'));
        this.tipo = (this.navParams.get('novidadeData') ? 'novidade' : 'atracao');

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Showview', '/showview-lista');

    }

    closeModal() {
        this.indexSelecionadoModal = "";

        this.viewCtrl.dismiss();
    }

    selectSv(index) {

        this.viewCtrl.dismiss({index: index});
    }

}



// WEBPACK FOOTER //
// ./src/pages/show/showview-lista/showview-lista.ts